import { Store } from "vuex";
import { Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

@Module({
  name: "amplitude",
  stateFactory: true,
  namespaced: true,
})
export default class AmplitudeStore extends VuexModule {
  rootReferrer: string | null = null;
  referringComponent: string | null = null;

  @Mutation
  setRootReferrer(rootReferrer: string | null) {
    this.rootReferrer = rootReferrer;
  }

  @Mutation
  setReferringComponent(referringComponent: string | null) {
    this.referringComponent = referringComponent;
  }
}

export const getAmplitudeStore = (store: Store<unknown>) => {
  const amplitudeStore = getModule(AmplitudeStore, store);

  return amplitudeStore;
};
